import { Utilities } from "../../shared/utilities";
import { IAgentData, IAgentGroupData, IAppReducerAction, IAppReducerOwnState } from "../shared/model";

const SET_ENVIRONMENTS = "SET_ENVIRONMENTS";
const SET_ISLOADING = "SET_ISLOADING";
const SET_AGENT_GROUP_AGENTS_WITH_STATUS = "SET_AGENT_GROUP_AGENTS_WITH_STATUS";

const GET_ENVIRONMENTS = "GET_ENVIRONMENTS";

export const initialState: IAppReducerOwnState = {
    environments: [],
    isLoading: true,
    userPermissions: Utilities.getAllUserPermissions(),
};

function updateAgentWithStatus(agent: IAgentData, statusUpdate: IAgentData): IAgentData {
    return {
        ...agent,
        id: statusUpdate.id,
        name: statusUpdate.name,
        agentVersion: statusUpdate.agentVersion,
        currentVersion: statusUpdate.currentVersion,
        friendlyUrl: statusUpdate.friendlyUrl,
        lastStatus: statusUpdate.lastStatus,
        lastUpdated: statusUpdate.lastUpdated,
        errorEventDuringLastDay: statusUpdate.errorEventDuringLastDay,
        reportedHttpPort: statusUpdate.reportedHttpPort,
        reportedHttpsPort: statusUpdate.reportedHttpsPort,
        reportedIsGateway: statusUpdate.reportedIsGateway,
        reportedConnectionString: statusUpdate.reportedConnectionString,
        reportedIsLimitedAgent: statusUpdate.reportedIsLimitedAgent,
        reportedLogStepsExecutionsToBlobs: statusUpdate.reportedLogStepsExecutionsToBlobs,
        isPrimaryAgent: statusUpdate.isPrimaryAgent,
        isSupportedAgentVersion: statusUpdate.isSupportedAgentVersion,
        isCrossPlatform: agent.isCrossPlatform,
        errorReason: statusUpdate.errorReason        
    };
}

function updateAgentList(agents: IAgentData[] | undefined, agentViewModels: IAgentData[]): IAgentData[] | undefined {
    if (!agents)
    {
        return agents;
    }
    
    const updatedAgents = agents.map(agent => {
        const statusUpdate = agentViewModels.find(vm => 
            vm.name && vm.name.toLowerCase() === (agent.name || "").toLowerCase()
        );
        
        if (!statusUpdate)
        {
            return agent;
        }

        return updateAgentWithStatus(agent, statusUpdate);     
    });

    return updatedAgents;
}

function updateAgentGroupIfMatch(
    agentGroup: IAgentGroupData, 
    targetGroupName: string, 
    agentViewModels: IAgentData[]
): IAgentGroupData {
    const isTargetGroup = (agentGroup.name || "").toLowerCase() === targetGroupName;
    
    if (!isTargetGroup)
    {
        return agentGroup;
    }

    return {
        ...agentGroup,
        executionAgents: updateAgentList(agentGroup.executionAgents, agentViewModels),
        gatewayAgents: updateAgentList(agentGroup.gatewayAgents, agentViewModels)
    };
}

export function reducer(state: IAppReducerOwnState, action: IAppReducerAction): IAppReducerOwnState {
    switch (action.type) {
        case SET_ENVIRONMENTS:
            return {
                ...state,
                environments: action.environments
            };
        case GET_ENVIRONMENTS:
            return {
                ...state,
                environments: state.environments
            };
        case SET_ISLOADING:
            return {
                ...state,
                isLoading: action.isLoading
            };
        case SET_AGENT_GROUP_AGENTS_WITH_STATUS:
        {
            const { agentViewModels, agentGroupName } = action;
            if (!agentViewModels || !agentGroupName)
            {
                return state;
            }

            const targetGroupName = agentGroupName.toLowerCase();

            const environments = state.environments.map(env => {
                if (!env.agentGroups)
                {
                    return env;
                }
                
                const hasTargetGroup = env.agentGroups.some(ag => 
                    (ag.name || "").toLowerCase() === targetGroupName
                );

                if (!hasTargetGroup)
                {
                    return env;
                }

                const agentGroups = env.agentGroups.map(ag => 
                    updateAgentGroupIfMatch(ag, targetGroupName, agentViewModels)
                );

                return {
                    ...env,
                    agentGroups
                };
            });

            return {
                ...state,
                environments
            };
        }
        default:
            return initialState;
    }
}